import z from "zod";
import { userSchema } from "../user";
import { createZodDto } from "nestjs-zod/dto";
import { souscriptionSchema } from "../souscription";

export const createCreditSchema = z.object({
  quantity: z.number(),
  remain: z.number().optional(),
  souscriptionId: z.string(),
  //startDate:z.coerce.date().optional(),
  //endDate:z.coerce.date().optional(),
  userId: z.string().optional(),
});

export const CreditSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  remain: z.number(),
  //startDate:z.coerce.date(),
  //endDate:z.coerce.date(),
  userId: z.string(),
  user: userSchema,
  souscriptionId: z.string().nullable(),
  souscription: souscriptionSchema.nullable(),
  expiresAt: z.coerce.date().nullable(),
  expiredAt: z.coerce.date().nullable(),
});

export const updateCreditSchema = createCreditSchema.partial();

export class CreateCreditDto extends createZodDto(createCreditSchema) {}

export class CreditDto extends createZodDto(CreditSchema) {}

export class UpdateCreditDto extends createZodDto(updateCreditSchema) {}
